

<form [formGroup]="form">
    <p>
        Es wird empfohlen, eine Begründung anzugeben, um Missverständnisse zu vermeiden.
        Sofern eingestellt, erhält der Kunde diese Begründung als E-Mail.
    </p>
    
    <label>Neuer Terminvorschlag?</label>
    <afs-radio-button-container formControlName="withNewAppointment">
        <afs-input-radio-button value="0">Nein</afs-input-radio-button>
        <afs-input-radio-button value="1">Ja, neuer Terminvorschlag</afs-input-radio-button>
    </afs-radio-button-container>
    
    @if(form.get("withNewAppointment")?.value === "1"){
    
        <div class="assign-wrapper">
            <label>Neuer Terminvorschlag</label>
            <afs-input-datetime style="display: block; margin-top: 10px;" formControlName="newAppointmentDate"></afs-input-datetime>
        </div>
    
        <div class="assign-wrapper">
            <label>Mitarbeiter auswählen (pflicht)</label>
            <assign-employees #assignEmployees [(selectedEmployeeIds)]="selectedEmployeeIds"></assign-employees>
        </div>
    
        <div class="assign-wrapper">
            <label> Dauer (pflicht)</label>
            <afs-input-select [options]="durationOptions" placeholder="Dauer..." [bindOnlyValue]="true" formControlName="selectedDuration" backdropClass="backdrop"></afs-input-select>
        </div>
    }
    
    <label>Begründung (optional)</label>
    <afs-input-textarea formControlName="rejectMessage" placeholder="Ablehnung weil..."></afs-input-textarea>

</form>